'use client';

import { useEffect, useRef, useState, type InputHTMLAttributes } from 'react';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'> & {
  value: string | number | null | undefined;
  onCommit: (v: string) => void;
};

/**
 * Controlled input whose value is mirrored in local state, so typing is synchronous and the
 * caret never jumps when the store re-renders the node. External value changes sync in only
 * when the field isn't focused.
 */
export function MirroredInput({ value, onCommit, ...rest }: Props) {
  const ref = useRef<HTMLInputElement>(null);
  const [local, setLocal] = useState(value == null ? '' : String(value));
  useEffect(() => {
    if (document.activeElement !== ref.current) setLocal(value == null ? '' : String(value));
  }, [value]);
  return (
    <input
      ref={ref}
      {...rest}
      value={local}
      onChange={(e) => {
        setLocal(e.target.value);
        onCommit(e.target.value);
      }}
    />
  );
}
